/**
 * https://github.com/jquense/yup/issues/507#issuecomment-765799429
 * Edited to allow empty string (^$), therefore it will validate the email only if the string exists.
 */
export const emailRegex =
  /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
